import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Style, Stroke, Fill, RegularShape, Circle, Icon } from 'ol/style.js';
import GeoJSON from "ol/format/GeoJSON";
import { Circle as CircleStyle, Text } from 'ol/style';
import { easeOut } from 'ol/easing.js';
import { fromLonLat } from 'ol/proj.js';
import { getVectorContext } from 'ol/render.js';
import { unByKey } from 'ol/Observable.js';
import { hexToRgba, settingsConfig } from 'utils/commonFunc';
import { reverseProgressValue, runAnimationFeature, runAnimationLayerList, setMapSingleEventHandler } from 'map/OlExtension'
import { Feature } from 'ol';
import { LineString, Point } from 'ol/geom';

export default class CommonMarkerLayer extends VectorLayer {

    constructor(map) {
        super({
            name: 'markerLayer',
            source: new VectorSource(),
        });
        this.map = map;
    }

    getDefaultStyle = (options) => {
        const { fillColor, storkeColor, zIndex, text } = {
            fillColor: "rgba(25, 255, 25, 0.5)",
            storkeColor: "rgba(25, 255, 25, 1)",
            zIndex: 1,
            text:undefined,
            ...options
        }      
        var style = new Style({
            image: new RegularShape({
                radius: 12,
                points: 3,
                angle: Math.PI,
                displacement: [0, 5],
                fill: new Fill({
                    color: fillColor
                }),
                stroke: new Stroke({
                    color: storkeColor,
                    width: 1
                })
            }),
            zIndex: zIndex
        })

        if (text) {
            style.setText(new Text({
                font: "14px 'NanumSquareNeo', 'Nanum Gothic', sans-serif",
                fill: new Fill({
                    color: "rgb(255, 255, 255)"
                }),
                stroke: new Stroke({
                    color: "rgb(100, 100, 100)",
                    width: 1
                }),
                padding: [3, 3, 2, 6],
                textBaseline: "top",
                offsetY: 0,
                text: `${text}`
            }))
        }
        return style
    };

    getBoxStyle = (options) => {
        const { fillColor, storkeColor, zIndex, radius } = {
            fillColor: "rgba(25, 255, 25, 0.7)",
            storkeColor: "rgba(25, 255, 25, 1)",
            zIndex: 1,
            radius: 8,
            ...options
        }      
        var style = new Style({
            image: new RegularShape({
                radius: radius,
                points: 4,
                angle: Math.PI / 4,
                //displacement: [0, 0],
                fill: new Fill({
                    color: fillColor
                }),
                stroke: new Stroke({
                    color: storkeColor,
                    width: 1
                })
            }),
            zIndex: zIndex
        })
        return style
    };

    getCircleStyle = (options) => {
        const { fillColor, storkeColor, zIndex, radius } = {
            fillColor: "rgba(25, 255, 25, 0.7)",
            storkeColor: "rgba(25, 255, 25, 1)",
            zIndex: 1,
            radius: 4,
            ...options
        }      
        var style = new Style({
            image: new Circle({
                radius: radius,
                //displacement: [0, 0],
                fill: new Fill({
                    color: fillColor
                }),
                stroke: new Stroke({
                    color: storkeColor,
                    width: 1
                })
            }),
            zIndex: zIndex
        })
        return style
    };

    getStationStyle = (options) => {
        const { fillColor, storkeColor, zIndex, radius, text } = {
            fillColor: "rgba(25, 255, 25, 0.5)",
            storkeColor: "rgba(25, 255, 25, 1)",
            zIndex: 1,
            radius: 3,
            ...options
        }      
        var style = new Style({
            image: new Circle({
                radius: radius,
                //displacement: [0, 0],
                fill: new Fill({
                    color: fillColor
                }),
                stroke: new Stroke({
                    color: storkeColor,
                    width: 1
                })
            }),
            zIndex: zIndex
        })

        if (text) {
            style.setText(new Text({
                font: "32px 'NanumSquareNeo', 'Nanum Gothic', sans-serif",
                fill: new Fill({
                    color: "rgb(255, 255, 255)"
                }),
                stroke: new Stroke({
                    color: "rgb(50, 50, 50)",
                    width: 2
                }),
                textBaseline: "top",
                offsetY: (radius ?? 6) * 2,
                text: `${text}`
            }))
        }
        return style
    };

    getVehicleStyle = (options) => {
        const { tp, scale, text, zIndex } = {
            ...options
        }  

        const style = new Style({
            // image: new RegularShape({
            //     angle: Math.PI,
            //     points: 4,
            //     radius: 20,
            //     fill: new Fill({
            //         color: p.color,
            //     }),
            //     stroke: new Stroke({
            //         color: 'rgba(255, 255, 255, 1.0)',
            //         width: 1
            //     }),
            //     scale: 0.5,
            // })
            image: new Icon({
                src: `/images/bis/bus_directions_icon_${tp}.png`,//'path/to/icon.png', // 아이콘 이미지 경로                        
                scale: scale ?? 1 + (-1 * 0.6), // 아이콘 크기 조절
              }),
              zIndex:zIndex
        })
        // if (text) {
        //     style.setText(new Text({
        //         font: "20px 'NanumSquareNeo', 'Nanum Gothic', sans-serif",
        //         fill: new Fill({
        //             color: "rgb(255, 255, 255)"
        //         }),
        //         stroke: new Stroke({
        //             color: "rgb(50, 50, 50)",
        //             width: 2
        //         }),
        //         textBaseline: "bottom",
        //         offsetY: -20,
        //         text: `${text}`
        //     }))
        // }
        return style
    };

    update = (features) => {
        const source = this.getSource()
        source.clear();
        features.forEach(feature => {
            if (!feature.getStyle()) {
                feature.setStyle(this.getDefaultStyle())
            }
        })
        source.addFeatures(features)
    }

    clear = () => {
        const source = this.getSource()
        source.clear();
    }

    add = (features) => {
        const source = this.getSource()
        features.forEach(feature => {
            if (!feature.getStyle()) {
                feature.setStyle(this.getDefaultStyle())
            }
        })
        source.addFeatures(features)
    }

    startAnimationImageScale = (styles, options) => { 
        const { defaultScale, overScale, startMs, overMs } = { defaultScale: 1.0, overScale: 1.2, startMs:600, overMs:300, ...options }       
        runAnimationLayerList(this, 'animationImageScale', [
            {
                totalMs:startMs, layerCallback: (progress) => {
                    styles.forEach(style => style.getImage()?.setScale(overScale * progress))
                    this.getSource().changed()
                }
            },
            {
                totalMs:overMs, layerCallback: (progress) => {
                    styles.forEach(style => style.getImage()?.setScale(defaultScale - progress * (overScale - defaultScale)))
                    this.getSource().changed()
                }
            },
        ], false)
    }
    getTriangleStyle = (options) => {
    const { fillColor, strokeColor, zIndex, size } = {
        fillColor: "rgba(25, 255, 25, 0.7)",
        strokeColor: "rgba(25, 255, 25, 1)",
        zIndex: 1,
        size: 4,
        ...options
    }
    
    var style = new Style({
        image: new RegularShape({
            points: 4,  // 4개의 점으로 사각형 생성
            radius: size,
            fill: new Fill({
                color: fillColor
            }),
            stroke: new Stroke({
                color: strokeColor,
                width: 1
            }),
            angle: Math.PI / 4  // 45도 회전시켜 마름모 형태로 표시
        }),
        zIndex: zIndex
    });
    
    return style
};
}